<template>
  <div class="login-container">
    <div class="login-form-div">
      
      <div class="step-info">
        <el-steps :active="active" finish-status="success">
          <el-step title="企业或机构信息" />
          <el-step title="等待审核" />
          <el-step title="审核状态" />
        </el-steps>
      </div>
      
      <div class="step-form-title" v-if="active !== 2">
        企业或机构
        <span>
          （请完善基础信息）
        </span>
      </div>
      
      <div class="first-step-form" v-if="active === 0">
        <el-form :model="formInfo" :rules="formRules" ref="ruleForm" label-position="top">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="企业或组织名称：" prop="dealName">
                <el-input v-model="formInfo.dealName" size="mini" placeholder="请输入企业或组织名称" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业或组织简称：" prop="dealAbbrName">
                <el-input v-model="formInfo.dealAbbrName" size="mini" placeholder="请输入企业或组织简称" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="社会统一组织机构代码:" prop="organizeNo">
                <el-input v-model="formInfo.organizeNo" size="mini" placeholder="请输入社会统一组织机构代码" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人1;" prop="contactName">
                <el-input v-model="formInfo.contactName" size="mini" placeholder="请输入联系人1" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业联系人1职务：" prop="contactPosition">
                <el-input v-model="formInfo.contactPosition" size="mini" placeholder="请输入企业联系人1职务" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人1手机号：" prop="contactPhone">
                <el-input v-model="formInfo.contactPhone" size="mini" placeholder="请输入联系人1手机号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人2：" prop="contactNameTwo">
                <el-input v-model="formInfo.contactNameTwo" size="mini" placeholder="请输入联系人2" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业联系人2职务：" prop="contactPositionTwo">
                <el-input v-model="formInfo.contactPositionTwo" size="mini" placeholder="请输入企业联系人2职务" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人2手机号：" prop="contactPhoneTwo">
                <el-input v-model="formInfo.contactPhoneTwo" size="mini" placeholder="请输入联系人2手机号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系地址：" prop="dealAddress">
                <el-input v-model="formInfo.dealAddress" size="mini" placeholder="请输入联系地址" />
              </el-form-item>
            </el-col>
            <el-col :span="24"></el-col>
            <el-col :span="8">
              <el-form-item label="系统登录手机号：" prop="adminPhone">
                <el-input v-model="formInfo.adminPhone" size="mini" placeholder="请输入系统登录手机号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机验证码：" prop="validCode">
                <el-input v-model="formInfo.validCode" size="mini" style="padding-top: 6px">
                  <el-button slot="append" type="primary" @click="sendCode">
                    {{ text }}
                  </el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div style="width: 100%; height: 37px;"></div>
              <el-button size="mini" @click="checkCode" :disabled="codeFlag">
                校验手机验证码
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
      <div class="first-step-form" v-if="active === 1">
        <div class="detail-mes-div flex">
          <div class="detail-title-div">企业或组织名称：</div>
          <div>{{ formInfo.dealName }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">企业或组织简称：</div>
          <div>{{ formInfo.dealAbbrName }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">社会统一组织机构代码：</div>
          <div>{{ formInfo.organizeNo }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">联系人1：</div>
          <div>{{ formInfo.contactName }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">企业联系人1职务：</div>
          <div>{{ formInfo.contactPosition }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">联系人1手机号：</div>
          <div>{{ formInfo.contactPhone }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">联系人2：</div>
          <div>{{ formInfo.contactNameTwo || '无'}}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">企业联系人2职务：</div>
          <div>{{ formInfo.contactPositionTwo || '无'}}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">联系人2手机号：</div>
          <div>{{ formInfo.contactPhoneTwo || '无'}}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">联系地址：</div>
          <div>{{ formInfo.dealAddress }}</div>
        </div>
        <div class="detail-mes-div flex">
          <div class="detail-title-div">系统登录手机号：</div>
          <div>{{ formInfo.adminPhone }}</div>
        </div>
      </div>
      
      <div class="first-step-form" v-if="active === 2">
        
        <div class="info-box" v-if="formInfo.auditStatus === '1'">
          <div class="item-box">
            <div>您好，你提交的账号申请已经启用！初始密码会通过短信的时候发送至您的手机中，请注意查收！</div>
            <el-button size="mini" @click="goLogin" type="primary">去登陆</el-button>
          </div>
        </div>
        <div  class="info-box" v-if="formInfo.auditStatus === '3'">
          <div class="item-box">
            <div>您好，您提交的账号申请已经被驳回！请仔细核对信息后再次提交审核！</div>
            <el-button size="mini" type="primary" @click="back">返回修改</el-button>
          </div>
        </div>
      </div>
      
      <el-button v-if="active === 0" size="mini" @click="next" :disabled="!codeFlag">
        下一步
      </el-button>
      
      <el-button v-if="active === 1" size="mini" @click="back">
        返回修改
      </el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        active: 0,
        
        btnCanUse: false,
        text: '获取验证码',
        second: 59,
        timer: null,
        timeFlag: true,
        
        formInfo: {
          dealName: '',
          dealAbbrName: '',
          organizeNo: '',
          contactName: '',
          contactPosition: '',
          contactPhone: '',
          contactNameTwo: '',
          contactPositionTwo: '',
          contactPhoneTwo: '',
          dealAddress: '',
          adminPhone: '',
          validCode: '',
          auditStatus: '',
        },
        formRules: {
          dealName: [{ required: true, message: '请输入企业或组织名称', trigger: 'blur' }],
          dealAbbrName: [{ required: true, message: '请输入企业或组织简称', trigger: 'blur' }],
          organizeNo: [{ required: true, message: '请输入社会统一组织机构代码', trigger: 'blur' }],
          contactName: [{ required: true, message: '请输入联系人1', trigger: 'blur' }],
          contactPosition: [{ required: true, message: '请输入企业联系人1职务', trigger: 'blur' }],
          contactPhone: [
            { required: true, message: '请输入联系人1手机号', trigger: 'blur' },
            {
              pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
              message: '手机号填写错误',
              trigger: 'blur'
            }
          ],
          dealAddress: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
          adminPhone: [
            { required: true, message: '请输入系统登录手机号', trigger: 'blur' },
            {
              pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
              message: '手机号填写错误',
              trigger: 'blur'
            }
          ],
          validCode: [
            { required: true, message: '请输入手机验证码', trigger: 'blur' },
          ],
        },
        
        codeFlag: false, // 校验验证码标志
      }
    },
    
    mounted() {
      this.init();
    },
    
    methods: {
      init() {
        localStorage.removeItem('userPhone')
        let _ = this;
        if (_.$route.query.editId) {
          _.active = 1;
          _.$H.post(_, _.$A.register.detailAccountForm, { dealId:  _.$route.query.editId}).then((res) => {
            _.formInfo = res.data.data || {};
            if(_.formInfo.auditStatus && (_.formInfo.auditStatus === '1' || _.formInfo.auditStatus === '3')) {
              _.$U.showLoading(_)
              setTimeout(() => {
                _.active = 2;
                _.$U.hideLoading(_);
              }, 3000)
            }
          })
        }
        
      },
      // 获取验证码
      sendCode() {
        let _ = this;
        if(_.btnCanUse) return;
        if (_.$U.isEmpty(_.formInfo.adminPhone)) {
          _.$U.error('请输入手机号');
          return;
        }

        const sendCode = _.$U.encrypted(_.formInfo.adminPhone + '_' + 'C01524100773815');
				const sign = (sendCode.slice(-4)).toUpperCase();

        // 获取验证码
        _.$H.post(_, _.$A.register.getCode, { corpNo: "C01524100773815", userPhone: _.formInfo.adminPhone }).then(res => {
        // _.$H.post(_, _.$A.register.getCode, { sendCodeSign: sign, corpNo: "C01524100773815", userPhone: sendCode }).then(res => {
          _.btnCanUse = true;
          _.doIt();
        })

      },
      // 获取验证码倒计时
      doIt () {
        let _ = this;
        _.text = _.second < 10 ? '0' + _.second  + ' 秒' : _.second + ' 秒';
        if(_.second === 1) {
          _.text = '重新获取';
          _.second = 59;
          _.btnCanUse = false;
          _.timeFlag = false;
        }
        _.second--;
        clearTimeout(_.timer);
        _.timer = null;
        if(_.timeFlag) {
          _.timer = setTimeout(() => {
            _.doIt();
          }, 1000);
        }
      },
      // 校验验证码
      checkCode() {
        let _ = this;
        if(_.$U.isEmpty(_.formInfo.adminPhone)) {
          _.$U.error('请输入手机号');
          return;
        }
        if (_.$U.isEmpty(_.formInfo.validCode)) {
          _.$U.error('请输入验证码');
          return;
        }
        const params = {
          corpNo: "C01524100773815",
          userPhone: _.formInfo.adminPhone,
          validCode: _.formInfo.validCode,
        }
        _.$H.post(_, _.$A.register.checkMessage, params).then(res => {
          console.log(res.data);
          _.codeFlag = res.data.data.flag;
        })
      },
      
      // 下一步
      next() {
        let _ = this;
        _.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (_.codeFlag) {
              _.$H.post(_, _.$A.register.addAccountForm, _.formInfo).then(res => {
                console.log(res.data.data, '0');
                const list = res.data.data || {};
                if (list) {
                  _.active = 1;
                  _.formInfo.id = list.id;
                  _.$router.push({
                    name: 'register',
                    query: {
                      editId: list.id
                    }
                  });
                  _.$U.success('请收藏当前网址，已备后续查看审核详情')
                }
              })
            }
            
          }
        })
        
      },
      // 返回修改
      back () {
        let _ = this;
        _.active = 0;
      },
      
      // 去登陆
      goLogin() {
        let _ = this;
        _.$router.push({
          name: 'login',
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  .login-container {
    width: 100%;
    height: 100%;
    background: linear-gradient(157deg, rgba(183, 128, 243, 1) 0%, rgba(89, 189, 255, 1) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    
    .login-form-div {
      width: 1127px;
      height: 720px;
      border-radius: 29px;
      background: white;
      
      padding: 24px;
      box-sizing: border-box;
      
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .step-info {
        width: 50%;
        margin-top: 24px;
        margin-bottom: 24px;

        /deep/ .is-process {
          color: #409EFF;
          border-color: #409EFF;
        }

      }
      
      .step-form-title {
        width:100%;
        text-align:left;
        font-size: 18px;
        font-weight: bolder;
        margin-bottom: 24px;
        
        span {
          font-size: 14px;
          font-weight: normal
        }
      }
      
      .first-step-form {
        width: 100%;
        
        .detail-mes-div{
          height: 30px;
          line-height: 30px;
          padding: 10px;
          margin-bottom: 10px;
          font-size: 14px;
        }
        
        .flex {
          display: flex;
          align-items: center;
        }
        
        .detail-title-div{
          width: 180px;
          text-align: right;
          margin-right: 50px;
        }
        
        .el-form--label-top /deep/ .el-form-item__label {
          padding: 0 !important;
        }
        
        /deep/ .el-form-item__label {
          line-height: 32px;
        }
        
        
        .info-box {
          width: 100%;
          height: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          
          .item-box {
            width: 480px;
            height: 200px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            
            div {
              text-align: center;
              font-size: 20px;
              font-weight: bold;
              
              margin-bottom: 32px;
            }
            
          }
        }
        
      }
      
    }
    
  }
</style>
